import type { HTMLAttributes } from 'react'
import { cx } from '../../cx'
import styles from './Badge.module.css'

export type BadgeTone = 'pink' | 'soft' | 'success' | 'warning' | 'warningOnDark'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone
}

/**
 * Mała pigułka mono — „POLECANY"/„NAJPOPULARNIEJSZY" (spec 05/07) oraz statusy
 * checklisty konfiguratora. Do statusów procesowych służy StatusPill.
 */
export function Badge({ tone = 'pink', className, ...rest }: BadgeProps) {
  return <span className={cx(styles.badge, styles[tone], className)} {...rest} />
}
